<template>
  <div class="page">
    <h2>客户类型管理</h2>
    <div class="toolbar">
      <button :disabled="loading" @click="openCreate">新增类型</button>
      <button :disabled="loading" @click="loadData">刷新</button>
    </div>
    <table>
      <thead>
        <tr><th>ID</th><th>类型</th><th>折扣率</th><th>状态</th><th>操作</th></tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.discountRate }}</td>
          <td>{{ item.status }}</td>
          <td>
            <button :disabled="loading" @click="openEdit(item)">编辑</button>
            <button :disabled="loading" @click="toggleStatus(item)">{{ item.status === 'ACTIVE' ? '禁用' : '启用' }}</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="showDialog" class="dialog-mask">
      <div class="dialog">
        <h3>{{ editingId ? '编辑客户类型' : '新增客户类型' }}</h3>
        <input v-model="form.name" placeholder="类型名称" />
        <input v-model.number="form.discountRate" type="number" placeholder="折扣率(%)" />
        <textarea v-model="form.description" placeholder="描述"></textarea>
        <div class="actions">
          <button :disabled="loading" @click="showDialog=false">取消</button>
          <button :disabled="loading" @click="save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customerTypeService } from '@/services/customerTypeService'

export default {
  name: 'CustomerTypeManagement',
  data() {
    return {
      list: [],
      form: { name: '', discountRate: 100, description: '', status: 'ACTIVE' },
      showDialog: false,
      editingId: null,
      loading: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await customerTypeService.fetchList()
        this.list = res.data || []
      } catch (e) {
        alert(e?.response?.data?.error || '加载客户类型失败')
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.editingId = null
      this.form = { name: '', discountRate: 100, description: '', status: 'ACTIVE' }
      this.showDialog = true
    },
    openEdit(item) {
      this.editingId = item.id
      this.form = { ...item }
      this.showDialog = true
    },
    async save() {
      this.loading = true
      try {
        if (this.editingId) await customerTypeService.update(this.editingId, this.form)
        else await customerTypeService.create(this.form)
        this.showDialog = false
        await this.loadData()
      } catch (e) {
        alert(e?.response?.data?.error || '保存客户类型失败')
      } finally {
        this.loading = false
      }
    },
    async toggleStatus(item) {
      if (!window.confirm(`确认${item.status === 'ACTIVE' ? '禁用' : '启用'}“${item.name}”吗？`)) return
      const status = item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
      this.loading = true
      try {
        await customerTypeService.updateStatus(item.id, status)
        await this.loadData()
      } catch (e) {
        alert(e?.response?.data?.error || '更新状态失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
